<template>
  <div class="role-box">
    <!-- search -->
    <div class="search">
      <el-button type="primary" size="small" plain @click="createRole"
        >创建权限组</el-button
      >
      <div>
        <el-input
          v-model="filterModel.searchVal"
          placeholder="请输入权限组名称查询"
          size="small"
          clearable
        ></el-input>
        <el-button class="search-btn" size="small" @click="getListAssignRole"
          >查询</el-button
        >
        <el-button class="search-btn" size="small" @click="rest"
          >重置</el-button
        >
      </div>
    </div>
    <!-- table -->
    <el-table :data="distributeRoles" border v-loading="tableLoading">
      <!-- <el-table-column prop="date" label="序号"> </el-table-column> -->
      <el-table-column prop="roleName" label="权限组名称"> </el-table-column>
      <el-table-column prop="remark" label="权限组描述"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span class="action pointer" @click="roleInfo(scope.row, 1)"
            >查看</span
          >
          <span
            v-if="!scope.row.sysCreated"
            class="action pointer"
            :class="{ 'dis-sty': !perms.includes(roleManage) }"
            @click="roleInfo(scope.row, 2)"
            >修改</span
          >
          <span
            v-if="!scope.row.sysCreated"
            class="action"
            :class="{
              'dis-sty':
                scope.row.sysCreated !== 0 ||
                (scope.row.sysCreated == 0 && !perms.includes(roleManage)),
            }"
            @click="delRole(scope.row)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-row class="pageation">
      <div style="padding: 30px 0" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="filterModel.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="filterModel.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="filterModel.total"
        />
        <el-go
          :page-size="filterModel.pageSize"
          :total="filterModel.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </div>
    </el-row>
    <!-- 窗口 -->
    <rloe-form
      v-if="dialogVisi"
      :diaTitle="diaTitle"
      :rowInfo="rowInfo"
      :viewDetail="viewDetail"
      :distributeRoles="distributeRoles"
      @closePup="closePup"
      @getRoles="getListAssignRole"
    ></rloe-form>
  </div>
</template>

<script>
// 接口
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// 组件
import ElGo from "@/components/go/Go.vue";
import rloeForm from "./components/rloeFormNew.vue";
// tool
import { mapGetters } from "vuex";
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";
import Bus from "@/plugins/bus.js";

export default {
  data () {
    return {
      roleManage: gantConf.roleManage,
      dialogVisi: false,
      filterModel: {
        searchVal: "",
        itemPage: 1,
        pageSize: 10,
        total: 0
      },
      distributeRoles: [],
      diaTitle: "创建权限组",
      viewDetail: false,
      rowInfo: {},
      tableLoading: false
    };
  }, // data end
  methods: {
    BusMonitoring () {
      let _this = this;
      Bus.$on("otherAddWay", () => {
        _this.$nextTick(() => {
          _this.createRole();
        });
      });
    },
    // 子组件关闭窗口
    closePup () {
      this.rowInfo = {};
      this.dialogVisi = false;
    },
    delRole (row) {
      const have = this.perms.includes(gantConf.roleManage)
      if (!have) {
        const Pinfo = getPermInfo(gantConf.roleManage)
        return this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      this.$confirm(
        '<p style="font-size: 16px;"><i class="el-icon-warning" style="color: #e6a23c;font-size: 20px; width: 30px;"></i>是否删除权限组</p><p style="font-size: 14px; color: #a6a69e;padding-left: 30px;"><span style="color: red;">删除权限组将不会恢复，你还要继续吗？</span></p>',
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: ""
        }
      )
        .then(async () => {
          let delRes = await ApiCorpMethods.RoleController.delRole({
            corpRoleId: row.corpRoleId
          });
          this.$message({
            type: "success",
            message: delRes.description
          });
          if (delRes.success) this.getListAssignRole();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /**
     * @param row 行数据
     * @param type 1 查看 2 修改
     */
    async roleInfo (row, type) {
      const have = this.perms.includes(gantConf.roleManage)
      if (!have && type === 2) {
        const Pinfo = getPermInfo(gantConf.roleManage)
        return this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      this.viewDetail = type === 1;
      this.diaTitle = type == 1 ? "权限组详情" : "修改权限组";
      this.getRoleInfo(JSON.parse(JSON.stringify(row)));
    },

    createRole () {
      const have = this.perms.includes(gantConf.roleManage)
      if (!have) {
        const Pinfo = getPermInfo(gantConf.roleManage)
        return this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      this.viewDetail = false;
      this.diaTitle = "创建权限组";
      this.dialogVisi = !this.dialogVisi;
    },
    getRoleInfo (row) {
      //获取角色详情,并回显
      let { corpRoleId } = row;
      ApiCorpMethods.RoleController.detail({
        corpRoleId
      }).then(res => {
        this.rowInfo = res.data;
        // 打开窗口
        this.dialogVisi = !this.dialogVisi;
      });
    },
    // 每页条数事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.getListAssignRole();
    },
    // 翻页
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.getListAssignRole();
    },
    // 重置
    rest () {
      this.filterModel.searchVal = "";
      this.getListAssignRole();
    },
    //获取 角色分配-角色
    async getListAssignRole () {
      this.tableLoading = true;
      let { itemPage, pageSize } = this.filterModel;
      let param = {
        corpUserId: this.currentAuthUser.corpUserId,
        roleName: this.filterModel.searchVal,
        itemPage,
        pageSize
      };
      let res = await ApiCorpMethods.RoleController.listAssignRole(param);
      this.distributeRoles = res.data;
      this.filterModel.total = res.total;
      this.tableLoading = false;
    }
  },
  components: { ElGo, rloeForm },
  created () {
    this.getListAssignRole();
    this.BusMonitoring()
  }, // created end
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    }
  },
  beforeDestroy(){
    Bus.$off("otherAddWay", () => {
        _this.$nextTick(() => {
          _this.createRole();
        });
      });
  }
};
</script>

<style scoped lang="less">
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:active,
.el-button--primary.is-plain:focus {
  color: #fff;
  background-color: #ec1c1c;
  border-color: #ec1c1c;
}
.el-table thead {
  color: #000 !important;
}
.action {
  color: #000;
  font-weight: bold;
  cursor: pointer;
  margin-right: 10px;
}
.dis-sty {
  color: #ccc;
  cursor: not-allowed;
}
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  margin-bottom: 20px;
  .search-btn {
    margin-left: 20px;
  }
}
.el-input {
  width: 300px;
}
.role-box {
  background-color: #fff;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// components/console/memberManage/roleCom.vue